// import React, { useEffect, useRef, useState } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css/navigation";
// import { Pagination, Autoplay } from "swiper/modules";
// import { Container, Row, Col } from "react-bootstrap";
// import { Link} from "react-router-dom";

// const CustomerReview = () => {

//     return (
//         <>
//             <Container>
//                 <Row className="align-items-center">
//                     <Col lg={12} className="text-center">
//                     <h2 className="mb-4">Happy Customers</h2>
//                     </Col>
//                     {/* LEFT - SLIDER */}
//                     <Col lg={8}>
//                     <Swiper
//                         modules={[Pagination, Autoplay]}
//                         pagination={{ clickable: true }}
//                         autoplay={{ delay: 2500 }}
//                         speed={1100}
//                         loop={true}
//                         spaceBetween={20}
//                         slidesPerView={1}
//                         breakpoints={{
//                             992: {
//                             slidesPerView: 2,
//                             },
//                         }}
//                         >
//                         <SwiperSlide>
//                         <div className="review-card">
//                             <p>
//                             Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod tempor incididunt ut labore et dolore Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
//                             </p>
//                             <div>
//                             <div className="stars">★★★★★</div>
//                             <h5>Annette Smith</h5>
//                             </div>
//                         </div>
//                         </SwiperSlide>

//                         <SwiperSlide>
//                         <div className="review-card">
//                             <p>
//                             Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod tempor incididunt ut labore et dolore Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
//                             </p>
//                             <div>
//                             <div className="stars">★★★★★</div>
//                             <h5>Annette Black</h5>
//                             </div>
//                         </div>
//                         </SwiperSlide>

//                         <SwiperSlide>
//                         <div className="review-card">
//                             <p>
//                             Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod tempor incididunt ut labore et dolore Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
//                             </p>
//                             <div>
//                             <div className="stars">★★★★★</div>
//                             <h5>Annette Black</h5>
//                             </div>
//                         </div>
//                         </SwiperSlide>
//                     </Swiper>
//                     </Col>

//                     {/* RIGHT - HIGHLIGHT BOX */}
//                     <Col lg={4}>
//                     <div className="review-highlight">
//                         <h1>99%</h1>
//                         <h6><b>Customer Satisfaction</b></h6>
//                         <p>
//                         We take pride in crafting beautiful wedding stationery that leaves a lasting impression. Your feedback helps us grow and serve you better.
//                         </p>
//                         <Link to="" className="offer-btn" onClick={() => window.open("https://g.page/r/YOUR-REVIEW-LINK/review", "_blank")}>
//                         Write a Review
//                         </Link>
//                     </div>
//                     </Col>

//                 </Row>
//                 </Container>
//         </>
//     );
// };

// export default CustomerReview;

import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

const GOOGLE_REVIEWS_URL =
  "https://www.google.com/search?q=graphe+weddings+reviews";

const WRITE_REVIEW_URL =
  "https://g.page/r/YOUR-REVIEW-LINK/review";

const reviews = [
  {
    id: 1,
    name: "Srishti Ahuja",
    meta: "4 reviews",
    date: "8 months ago",
    rating: 5,
    text: `Weddings by Graphe did an absolutely amazing job designing our wedding invites! Sneha was such a delight to work with—so creative, patient, and full of ideas that perfectly captured our personalities. From colours and fonts to the tiniest details, the experience was wonderful.`,
  },
  {
    id: 2,
    name: "Aishwaria Manek",
    meta: "7 reviews",
    date: "11 months ago",
    rating: 5,
    text: `I had a wonderful experience working with the Graphe team. Sneha and Yashashwi tried to understand us as a couple, our vibe, and shared very creative moodboards and ideas for our invite. They also worked very hard to meet our deadlines.`,
  },
  {
    id: 3,
    name: "Navya Sree",
    meta: "2 reviews",
    date: "2 years ago",
    rating: 5,
    text: `Very talented and highly professional team to work with. Sneha and her team were very patient with our requirements, and the outcome was exactly like we imagined it to be. We are thankful to the team and very happy with the execution.`,
  },
  {
    id: 4,
    name: "Kushal Bhikadiya",
    meta: "Local Guide · 14 reviews · 3 photos",
    date: "1 year ago",
    rating: 5,
    text: `Prathana has been absolutely amazing to work with! She helped us create the most incredible wedding invite for my fiancé and me. She came up with a super creative design and patiently listened to all our feedback.`,
  },
  {
    id: 5,
    name: "Iman Nizardeen",
    meta: "16 reviews",
    date: "8 months ago",
    rating: 5,
    text: `Had a great experience working with Graphe on my digital invites. I used them for my save-the-dates as well as my official invites, and the team executed our vision beautifully!`,
  },
  {
    id: 6,
    name: "Vinayak Rajakannu",
    meta: "Local Guide · 20 reviews · 3 photos",
    date: "3 years ago",
    rating: 5,
    text: `A fantastic Save the Date was created for us by Shreyashi and her team! They worked diligently and produced the exact film we had in mind. They were patient with us and listened to all our requests.`,
  },
  {
    id: 7,
    name: "Vidhu K",
    meta: "7 reviews · 4 photos",
    date: "3 years ago",
    rating: 5,
    text: `What best could happen if you are having your dream wedding with a perfect dream invite? Best wedding invite ever. From taking timely inputs to satisfying us at every moment with our requirements and making necessary changes when needed, the experience was excellent.`,
  },
  {
    id: 8,
    name: "Sonia Sharma",
    meta: "7 reviews",
    date: "2 years ago",
    rating: 5,
    text: `At first, I was hesitant since I'm not in the same country, but the team was incredibly amazing to work with. Despite the short timeframe, they delivered an outstanding video. Sneha and the animators were very patient with all my minor edits. Everything was exceptionally well done!`,
  },
  {
    id: 9,
    name: "Louie Pathirana",
    meta: "Local Guide · 54 reviews · 41 photos",
    date: "3 years ago",
    rating: 5,
    text: `If you're looking for an amazing wedding invitation experience, look no further than Weddings by Graphe. From start to finish, they were a joy to work with. They captured our love story perfectly in our save-the-date card.`,
  },
  {
    id: 10,
    name: "Divya Bohara",
    meta: "5 reviews · 4 photos",
    date: "4 years ago",
    rating: 5,
    text: `The work provided by Weddings by Graphē was exceptional. Right from understanding what we wanted to brainstorming and executing it in our invitation, they managed to surpass our expectations many times over.`,
  },
  {
    id: 11,
    name: "POM ROON",
    meta: "8 reviews · 1 photo",
    date: "3 years ago",
    rating: 5,
    text: `Graphē was an absolute pleasure to work with. My invitation was beautifully executed. Communication was very easy across time zones, through every idea and every edit. No changes were made without confirmation at every step.`,
  },
  {
    id: 12,
    name: "Pratish Bhosale",
    meta: "Local Guide · 11 reviews · 2 photos",
    date: "4 years ago",
    rating: 5,
    text: `Best wedding invitation video we got. We had a Marathi royal theme in mind, and they did it very well. From understanding our requirements to changing the drafts, the team did great work. Thank you for making such a memorable invitation that our family loved.`,
  },
  {
    id: 13,
    name: "Ruchi Foujdar",
    meta: "5 reviews · 13 photos",
    date: "4 years ago",
    rating: 5,
    text: `I can’t express how happy and excited I was to receive my digital wedding invite. They made it so beautifully, and everything looked perfect. The card was beyond my expectations, and it was easy to explain my requirements to the team.`,
  },
  {
    id: 14,
    name: "Mihir Patel",
    meta: "Local Guide · 12 reviews · 2 photos",
    date: "4 years ago",
    rating: 5,
    text: `Graphē Weddings and the team did an amazing job creating the invite for our engagement. They walked us through the entire process from the beginning until delivery. The team carefully understood our requirements and gave us proper time and attention.`,
  },
  {
    id: 15,
    name: "Janani V.",
    meta: "6 reviews · 1 photo",
    date: "4 years ago",
    rating: 5,
    text: `The best wedding invitation creators and designers you will find! We were in a jam, and Weddings by Graphe came to the rescue. They brought what we had imagined to life in a magical and perfect wedding invitation.`,
  },
  {
    id: 16,
    name: "Aanchal Mahajan",
    meta: "Local Guide · 14 reviews · 1 photo",
    date: "4 years ago",
    rating: 5,
    text: `Amazing graphic designers. They spoke to me and my husband initially to understand our story and bring it to life through caricatures. They stayed constantly in touch for every little change and brought out the best result.`,
  },
  {
    id: 17,
    name: "Raina Rangnani",
    meta: "Local Guide · 23 reviews · 7 photos",
    date: "2 years ago",
    rating: 5,
    text: `This amazing team created the most beautiful wedding invite for us. It was perfect to the T, with all the details I wanted, and I couldn't have asked for anyone better to design my wedding invitations.`,
  },
  {
    id: 18,
    name: "Nitin Sadani",
    meta: "8 reviews",
    date: "1 year ago",
    rating: 5,
    text: `Excellent teamwork from Weddings by Graphe. It wasn't a wedding invite, but they worked to perfection according to my requirements. Great job, guys!`,
  },
  {
    id: 19,
    name: "Aakriti Bhatia",
    meta: "Local Guide · 13 reviews",
    date: "4 years ago",
    rating: 5,
    text: `Team Graphe helped turn my imagination into reality. Sammani was absolutely amazing and patient. She always understood our requirements and ensured the outcome was perfect. Choosing them for my special day was the best decision!`,
  },
  {
    id: 20,
    name: "Prakriti Bhattacharya",
    meta: "4 reviews",
    date: "4 years ago",
    rating: 5,
    text: `Very talented team, dedicated to their clients. They will fine-tune their work until it looks perfect. The best choice if you want your dream wedding invite!`,
  },
  {
    id: 21,
    name: "Shruti Rai",
    meta: "5 reviews",
    date: "3 years ago",
    rating: 5,
    text: `Aishwarya and the team went above and beyond to create such a lovely invite for us. They were prompt and tailored the invite based on our feedback. I would highly recommend them.`,
  },
  {
    id: 22,
    name: "Ruth Samuel",
    meta: "Local Guide · 15 reviews · 17 photos",
    date: "4 years ago",
    rating: 5,
    text: `Loved the invite they designed for my sangeet. I also loved that throughout the design process they made me a part of every detail, and the final outcome was much better than I imagined. Thank you for all your efforts. Keep rocking!`,
  },
  {
    id: 23,
    name: "Mh venture Arul",
    meta: "Local Guide · 11 reviews · 4 photos",
    date: "4 years ago",
    rating: 5,
    text: `The Graphē team delivered excellent artwork and customised caricatures for the wedding and reception welcome boards. Great hospitality by the team.`,
  },
  {
    id: 24,
    name: "Hiten Shah",
    meta: "8 reviews",
    date: "1 year ago",
    rating: 5,
    text: `They did an exceptional job with our animation movie while meeting strict deadlines. I would highly recommend them.`,
  },
  {
    id: 25,
    name: "Sushree Mahapatra",
    meta: "Local Guide · 24 reviews · 38 photos",
    date: "4 years ago",
    rating: 5,
    text: `We loved their creativity and the way they focused on every detail and input to create a masterpiece. They were very responsive and handled the project with great professionalism.`,
  },
  {
    id: 26,
    name: "Ashi Bajpai",
    meta: "1 review",
    date: "4 years ago",
    rating: 5,
    text: `Highly professional, patient and talented team of people. They delivered the requirements on time and did a great job with our invitation. Good luck to the team for the future!`,
  },
  {
    id: 27,
    name: "Kareena Gandhi",
    meta: "1 review",
    date: "4 years ago",
    rating: 5,
    text: `Amazing graphic designers. They spoke to me and my husband initially to understand our story and bring it to life through caricatures. They stayed in touch for every little change and created the best result. We cannot thank them enough for the lifetime memory.`,
  },
  {
    id: 28,
    name: "Sourav Chakraborty",
    meta: "Local Guide · 241 reviews · 2,383 photos",
    date: "4 years ago",
    rating: 5,
    text: `The Graphe team worked closely with us to create a beautiful and personalised digital invitation card for our wedding. Highly recommended.`,
  },
  {
    id: 29,
    name: "Monisha Reddy Pathpireddy",
    meta: "11 reviews · 8 photos",
    date: "2 years ago",
    rating: 5,
    text: `Had a lovely experience with them. They were very patient throughout the process, including with the last-minute changes, and were transparent about what I would receive throughout the entire process. Thank you so much!`,
  },
  {
    id: 30,
    name: "Sampurna Maity",
    meta: "Local Guide · 15 reviews · 35 photos",
    date: "4 years ago",
    rating: 5,
    text: `Couldn't thank the entire team enough for putting in such an effort and delivering a beautiful outcome for my brother's reception invite. Thanks so much, team. Highly recommended!`,
  },
  {
    id: 31,
    name: "Sanya C",
    meta: "9 reviews",
    date: "1 year ago",
    rating: 5,
    text: `Amazing work! The team is very patient and understands the vision. Highly recommended.`,
  },
  {
    id: 32,
    name: "Arpita Jani",
    meta: "Local Guide · 11 reviews · 17 photos",
    date: "4 years ago",
    rating: 5,
    text: `Absolutely talented and creative team. Loved their work and would definitely recommend them to my friends and family!`,
  },
  {
    id: 33,
    name: "Snigdha Chaturvedi",
    meta: "Local Guide · 9 reviews",
    date: "3 years ago",
    rating: 5,
    text: `Great work—from illustration and conceptualisation to high-quality rendition, they are the perfect go-to solution for all kinds of invitations.`,
  },
];

const StarRating = ({ rating }) => {
  return (
    <div
      className="review-stars"
      aria-label={`${rating} out of 5 stars`}
    >
      {Array.from({ length: 5 }, (_, index) => (
        <span
          key={index}
          className={index < rating ? "active" : ""}
        >
          ★
        </span>
      ))}
    </div>
  );
};

const CustomerReview = () => {
  const [expandedReviewId, setExpandedReviewId] = useState(null);

  const positiveReviews = reviews.filter(
    (review) => review.rating >= 4
  );

  const toggleReview = (reviewId) => {
    setExpandedReviewId((currentId) =>
      currentId === reviewId ? null : reviewId
    );
  };

  return (
    <Container className="customer-review-container">
      <Row className="align-items-stretch">
        <Col lg={12} className="text-center">
          <h2 className="customer-review-title">
            Happy Customers
          </h2>
        </Col>

        {/* LEFT — REVIEW SLIDER */}
        <Col lg={8} className="d-flex">
          <div className="manual-review-slider">
            <Swiper
              modules={[Pagination, Autoplay]}
              pagination={{
                clickable: true,
                dynamicBullets: true,
              }}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              speed={900}
              loop={positiveReviews.length > 2}
              spaceBetween={20}
              slidesPerView={1}
              breakpoints={{
                992: {
                  slidesPerView: 2,
                },
              }}
              className="customer-review-swiper"
            >
              {positiveReviews.map((review) => {
                const isExpanded =
                  expandedReviewId === review.id;

                return (
                  <SwiperSlide key={review.id}>
                    <article className="review-card">
                      <div className="review-card-header">
                        <div className="review-avatar">
                          {review.name.charAt(0).toUpperCase()}
                        </div>

                        <div className="review-author-info">
                          <h5>{review.name}</h5>

                          <p className="review-meta">
                            {review.meta}
                          </p>

                          <p className="review-date">
                            {review.date}
                          </p>
                        </div>
                      </div>

                      <StarRating rating={review.rating} />

                      <p
                        className={`review-text ${
                          isExpanded ? "expanded" : "collapsed"
                        }`}
                      >
                        {review.text}
                      </p>

                      {review.text.length > 180 && (
                        <button
                          type="button"
                          className="review-read-more"
                          onClick={() => toggleReview(review.id)}
                        >
                          {isExpanded ? "Show less" : "Read more"}
                        </button>
                      )}

                      <div className="review-card-footer">
                        <a
                          href={GOOGLE_REVIEWS_URL}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="view-google-review"
                        >
                          <span className="google-letter">G</span>
                          View reviews on Google
                        </a>
                      </div>
                    </article>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </Col>

        {/* RIGHT — HIGHLIGHT BOX */}
        <Col lg={4} className="d-flex">
          <div className="review-highlight">
            <h1>99%</h1>

            <h6>
              <strong>Customer Satisfaction</strong>
            </h6>

            <p>
              We take pride in crafting beautiful wedding stationery
              that leaves a lasting impression. Your feedback helps us
              grow and serve you better.
            </p>

            {/* <p className="review-total">
              Based on {positiveReviews.length} selected customer
              reviews
            </p> */}

            <a
              href={WRITE_REVIEW_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="offer-btn"
            >
              Write a Review
            </a>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default CustomerReview;